export const lx = `/api/templates`
export const lxtj = `/api/collections/dangers/ccds`
export const tj = `/api/collections/dangers/csds`
export const yh = `/api/collections/dangers`
export const qytj = `/api/templates/postions/ccds`
export const qy = `/api/templates/postions`
export const mothEcharts = `/api/collections/dangers/cgbm`
export const typeEcharts = `/api/collections/dangers/cgbs`
export const qyEcharts = `/api/collections/dangers/cabs`

